<div class="page-container">
  <app-page-header
    title="Commercial Request #{{ id }}"
    [showBackButton]="true"
    backRoute="/production-requests"
    backLabel="Back">
    @if (isUserRole) {
      <button class="btn-help-order"
        type="button"
        (click)="helpWithCommercialRequest()">
        <svg width="16" height="16" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
        Help with this Request
      </button>
    }
    @if (canCreateCommercial()) {
      <button class="btn-primary filter-btn" [routerLink]="['/production-requests', id, 'create-commercial']">
        <span class="icon material-icons" aria-hidden="true">add</span>
        <span class="btn-label">Create Commercial</span>
      </button>
    }
  </app-page-header>

  @if (loading) {
    <div class="loading-wrap">
      <app-data-loader [show]="true" message="Loading…" size="medium" />
    </div>
  } @else if (error) {
    <div class="error-message" role="alert">{{ error }}</div>
  } @else if (detail) {
    @if (successMessage) {
      <div class="success-message" role="status">{{ successMessage }}</div>
    }

    <section class="card section-request">
      <h2>Commercial Details</h2>
      <div class="request-meta">
        <span class="status-badge" [ngClass]="getStatusClass(detail.request.status)">
          {{ statusLabels[detail.request.status] || detail.request.status }}
        </span>
        <span>Station: {{ detail.request.station_name || '-' }}</span>
        <span>Created: {{ detail.request.created_at | date:'medium' }}</span>
        @if (detail.request.duration) {
          <span>Duration: {{ detail.request.duration }}s</span>
        }
      </div>
      <div class="request-fields">
        <div class="field">
          <label>What does your business do?</label>
          <p>{{ detail.request.what_business_does || '-' }}</p>
        </div>
        <div class="field">
          <label>Campaign goal</label>
          <p>{{ detail.request.campaign_goal || '-' }}</p>
        </div>
        <div class="field">
          <label>Unique selling point</label>
          <p>{{ detail.request.unique_selling_point || '-' }}</p>
        </div>
        <div class="field">
          <label>What should listeners do after hearing this ad?</label>
          <p>{{ detail.request.call_to_action || '-' }}</p>
        </div>
      </div>
    </section>

    <section class="card section-additional-info">
      <h2>Additional Information</h2>
      @if (isStationRole && !isApproved) {
        <div class="additional-info-station">
          @if (messages.length > 0) {
            <div class="qa-history">
              @for (msg of messages; track msg.id) {
                <div class="qa-item" [class.from-station]="!isFromUser(msg)" [class.from-user]="isFromUser(msg)">
                  <span class="qa-label">{{ isFromUser(msg) ? 'Customer reply' : 'Your question' }}</span>
                  <p class="qa-text">{{ msg.message }}</p>
                  <span class="qa-meta">{{ msg.created_at | date:'short' }}</span>
                </div>
              }
            </div>
          }
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Request information from customer</mat-label>
            <textarea matInput [(ngModel)]="requestMoreInfoText" name="requestMoreInfo" rows="3"
              placeholder="What additional information do you need?"></textarea>
          </mat-form-field>
          <div class="reply-actions">
            <button mat-raised-button color="primary" (click)="requestMoreInfo()"
              [disabled]="sendingMoreInfo || !requestMoreInfoText.trim()">
              @if (sendingMoreInfo) { Sending... } @else { Request Information }
            </button>
          </div>
        </div>
      }
      @if (isUserRole && messages.length > 0) {
        <div class="additional-info-user">
          <div class="qa-history">
            @for (msg of messages; track msg.id) {
              <div class="qa-item" [class.from-station]="!isFromUser(msg)" [class.from-user]="isFromUser(msg)">
                <span class="qa-label">{{ isFromUser(msg) ? 'Your reply' : 'Question' }}</span>
                <p class="qa-text">{{ msg.message }}</p>
                <span class="qa-meta">{{ msg.created_at | date:'short' }}</span>
              </div>
            }
          </div>
          @if (canUserReply()) {
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Your reply</mat-label>
              <textarea matInput [(ngModel)]="replyMessage" name="reply" rows="3"
                placeholder="Provide the requested information..."></textarea>
            </mat-form-field>
            <div class="reply-actions">
              <button mat-raised-button color="primary" (click)="postReply()"
                [disabled]="sendingMessage || !replyMessage.trim()">
                @if (sendingMessage) { Sending... } @else { Send reply }
              </button>
            </div>
          }
        </div>
      }
      @if (isUserRole && messages.length === 0) {
        <p class="muted">No additional information has been requested yet. When the station asks for more details, you can reply here.</p>
      }
    </section>

    <section class="card section-audio">
      <h2>Audio versions</h2>
      @if (detail.audio_versions.length === 0) {
        <p class="muted">No audio uploaded yet.</p>
      } @else {
        <div class="audio-versions">
          @for (av of detail.audio_versions; track av.id) {
            <div class="audio-version-card">
              <div class="audio-version-header">
                <h4>Version {{ av.version }}</h4>
                <span class="status-chip" [ngClass]="getAudioVersionStatusClass(av.status)">
                  {{ getAudioVersionStatusLabel(av.status) }}
                </span>
              </div>
              <p class="uploaded-meta">Uploaded {{ av.created_at | date:'medium' }}</p>
              @if (av.audio_url) {
                <audio [src]="av.audio_url" controls preload="metadata"></audio>
              }
              @if (audioVersionProductTypes[av.id]?.length) {
                <div class="product-type-chips">
                  @for (pt of audioVersionProductTypes[av.id]; track pt.id) {
                    <span class="status-chip chip-approved product-type-chip">{{ productTypeLabel(pt) }}</span>
                  }
                </div>
              }
              @if (av.decline_reason && (av.status === 'declined')) {
                <div class="decline-reason">
                  <strong>Decline reason:</strong> {{ av.decline_reason }}
                </div>
              }
              @if (canApproveVersion(av) || canDeclineVersion(av)) {
                <div class="version-actions">
                  @if (canApproveVersion(av)) {
                    <button mat-raised-button color="primary" (click)="openApproveModal(av)">
                      <mat-icon>check_circle</mat-icon>
                      Approve
                    </button>
                  }
                  @if (canDeclineVersion(av)) {
                    <button mat-raised-button color="warn" (click)="openDeclineModal(av)">
                      <mat-icon>cancel</mat-icon>
                      Decline
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </section>

    @if (detail.feedback && detail.feedback.length > 0 && !isUserRole) {
      <section class="card section-feedback">
        <h2>Decline feedback</h2>
        @for (fb of detail.feedback; track fb.id) {
          <div class="feedback-item">
            @if (fb.explanation) {
              <p><strong>Explanation:</strong> {{ fb.explanation }}</p>
            }
            @if (fb.missing_information) {
              <p><strong>Missing information:</strong> {{ fb.missing_information }}</p>
            }
            <span class="muted">{{ fb.created_at | date:'medium' }}</span>
          </div>
        }
      </section>
    }
  }
</div>
